import { z } from "zod";
import { CSSPropertyEnum } from "../pageStyles";
import { SubSchema } from "../sub";
/**
 * Tells the paywall to update the variables passed into liquid
 */ const IncomingMessageTemplateVariablesSchema = z.object({
    event_name: z.literal("template_variables"),
    variables: z.object({}).passthrough()
});
/**
 * Tells the paywall update the substitutions
 */ const IncomingMessageTemplateSubstitutionsSchema = z.object({
    event_name: z.literal("template_substitutions"),
    substitutions: z.array(SubSchema)
});
/**
 * Tells the paywall that a substitution input is focused
 */ const IncomingMessageIsSubstitutionFocused = z.object({
    event_name: z.literal("substitution_editor_focused")
});
/**
 * Tells the paywall that a substitution input is blurred
 */ const IncomingMessageIsSubstitutionBlurred = z.object({
    event_name: z.literal("substitution_editor_blurred")
});
/**
 * Tells the paywall to start using a different set of substitutions
 */ const IncomingMessageSubstitutionsPrefixSchema = z.object({
    event_name: z.literal("template_substitutions_prefix"),
    prefix: z.union([
        z.string(),
        z.null()
    ])
});
export const ProductIdentifierAndTypeSchema = z.object({
    product: z.string(),
    productId: z.string()
});
const IncomingMessageProductsSchema = z.object({
    event_name: z.literal("products"),
    products: z.array(ProductIdentifierAndTypeSchema)
});
/**
 * Tells the paywall we received a game controller input
 */ const IncomingMessageGameControllerInputDirectionalSchema = z.object({
    event_name: z.literal("game_controller_input"),
    controller_element: z.string(),
    directional: z.literal(true),
    x: z.number(),
    y: z.number()
});
/**
 * Tells the paywall we received a game controller input
 */ const IncomingMessageGameControllerInputNonDirectionalSchema = z.object({
    event_name: z.literal("game_controller_input"),
    controller_element: z.string(),
    directional: z.literal(false),
    value: z.number()
});
const IncomingMessageGameControllerInputSchema = z.union([
    IncomingMessageGameControllerInputDirectionalSchema,
    IncomingMessageGameControllerInputNonDirectionalSchema
]);
const IncomingMessageBackButtonInputSchema = z.object({
    event_name: z.literal("back_button_input"),
    pressed: z.boolean()
});
const IncomingMessageFocusSubstitutionSchema = z.object({
    event_name: z.literal("focus_substitution"),
    key: z.string()
});
const IncomingMessageUnFocusSubstitutionSchema = z.object({
    event_name: z.literal("unfocus_substitution")
});
const IncomingMessageFocusHoveredSubstitutionSchema = z.object({
    event_name: z.literal("focus_hovered_substitution"),
    key: z.string()
});
const IncomingMessageUnFocusHoveredSubstitutionSchema = z.object({
    event_name: z.literal("unfocus_hovered_substitution")
});
const IncomingMessagePageStyles = z.object({
    event_name: z.literal("page_styles"),
    pageStyles: z.array(z.object({
        from: z.string(),
        to: z.string(),
        property: CSSPropertyEnum
    }))
});
const IncomingMessageTemplateJSON = z.object({
    event_name: z.literal("template_json"),
    json: z.object({}).passthrough(),
    reset: z.boolean().optional()
});
const IncomingMessagePaywallOpen = z.object({
    event_name: z.literal("paywall_open"),
    paywall_id: z.string(),
    paywall_identifier: z.string()
});
export const IncomingMessageSchema = z.union([
    IncomingMessageTemplateVariablesSchema,
    IncomingMessageTemplateSubstitutionsSchema,
    IncomingMessageSubstitutionsPrefixSchema,
    IncomingMessageProductsSchema,
    IncomingMessageGameControllerInputSchema,
    IncomingMessageBackButtonInputSchema,
    IncomingMessageFocusSubstitutionSchema,
    IncomingMessageUnFocusSubstitutionSchema,
    IncomingMessageFocusHoveredSubstitutionSchema,
    IncomingMessageUnFocusHoveredSubstitutionSchema,
    IncomingMessageIsSubstitutionFocused,
    IncomingMessageIsSubstitutionBlurred,
    IncomingMessagePageStyles,
    IncomingMessageTemplateJSON,
    IncomingMessagePaywallOpen
]);
